import refreshRecordBuilder from "quickfire/integration/builders/record/refresh-record-builder";
import Gameplay from "slotworks/model/gameplay/gameplay";
import AuthRequestPayload from "slotworks/model/gameplay/requests/auth-request-payload";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import sgRecoverySpinRecordBuilder from "./sg-recovery-spin-record-builder";

class SGRefreshRecordBuilder implements RecordBuilder {
    public filter(request: any, response: any): boolean {
        return request instanceof AuthRequestPayload && !sgRecoverySpinRecordBuilder.filter(request, response);
    }

    public build(gameplay: Gameplay, request: any, packet: QuickfireResponsePacket) {
        return refreshRecordBuilder.build(gameplay, request, packet);
    }
}

export default new SGRefreshRecordBuilder();
